import React from 'react'
import { Typography, Box } from '@material-ui/core'

const LabelValuePair = ({ ...overrides }) => {
  const labelValuePairConfig = {
    labelWidth: '10em',
    ...overrides,
  }

  const label = labelValuePairConfig.label
  const labelWidth = labelValuePairConfig.labelWidth
  const noWrapValue =
    labelValuePairConfig.noWrapValue !== undefined ? labelValuePairConfig.noWrapValue : true
  const value = labelValuePairConfig.value

  return (
    <Box alignItems="center" display="flex" flexWrap="nowrap" mb={1}>
      <Box mr={2}>
        <Typography alignContent="center" className="Label" style={{ width: labelWidth }}>
          {label}:
        </Typography>
      </Box>
      <Box>
        <Typography alignContent="center" className="Value" noWrap={noWrapValue}>
          {value}
        </Typography>
      </Box>
    </Box>
  )
}

export default LabelValuePair
